import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

const CHEST_TUBE_RATE = "Chest Tube Rate (mL/hr)";
const CHEST_TUBE_OUTPUT = "Chest Tube Output (mL)";

@Component({})
export default class ChestTube extends mixins(GraphRanges) {
  @Getter("segmentRisk", patientNamespace)
  segmentRisk!: any;

  @Getter("graph", patientNamespace)
  graph!: any;

  get charts(): MultiChartConfig[] {
    const outputLibrary = {
      legend: {
        labels: {
          usePointStyle: true
        },
        display: false
      },
      scales: {
        yAxes: [
          {
            stacked: true
          }
        ],
        xAxes: [
          {
            maxBarThickness: 8,
            minBarThickness: 6,
            barThickness: 6,
            stacked: true
          }
        ]
      }
    };

    return [
      {
        data: this.graph([{ key: "chestTubeRate", label: CHEST_TUBE_RATE }]),
        title: CHEST_TUBE_RATE
      },
      {
        type: "bar",
        data: this.graph([{ key: "ChestTube", label: CHEST_TUBE_OUTPUT }]),
        title: CHEST_TUBE_OUTPUT,
        library: outputLibrary
      }
    ];
  }
}
